import { render, staticRenderFns } from "./excavate_statistics.vue?vue&type=template&id=f05b6f20"
import script from "./excavate_statistics.vue?vue&type=script&lang=js"
export * from "./excavate_statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports